import script from "./beikepingdingdetail.vue?vue&type=script&setup=true&lang=js"
export * from "./beikepingdingdetail.vue?vue&type=script&setup=true&lang=js"

import "./beikepingdingdetail.vue?vue&type=style&index=0&id=86356974&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-86356974"]])

export default __exports__